import Index from './index.vue'
import Layout from './layout.vue'

const main_router = 'provider_uploader'

const router = [
    {
        path: ':operation_identity?',
        component: Index,
        name: 'provider_uploader',
        meta: {
            api_name: [
                'api_v1_provider_customer_nodes',
                'api_v1_provider_operation_create',
                'api_v1_provider_operation_use_core_waybill',
                'api_v1_provider_operation_validate',
                'api_v1_provider_file_converters',
                'api_v1_provider_file_convert',
                'api_v1_provider_file_converter_open'
            ],
            breadcrumb: [main_router]
        }
    },
]
export default router
